import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { useQueryLocalEditor } from 'gql/queries/local';

import Questions from './Questions';

const QuestionsContainer = ({ chapterId, course, ...props }) => {
  const questions = useMemo(() => {
    const qs =
      (chapterId === null
        ? course.questions
        : course.chapters.find((c) => c.id === chapterId)?.questions) || [];
    return [...qs].sort((q1, q2) =>
      q1.type === 'HomeScreen' && q2.type === 'HomeScreen'
        ? q1.order - q2.order
        : q2.type === 'HomeScreen'
        ? 1
        : 0,
    );
  }, [chapterId, course]);
  const {
    data: {
      editor: { questionsSelected },
    },
  } = useQueryLocalEditor();
  const selectedIds = useMemo(
    () => questionsSelected.map((question) => question.id),
    [questionsSelected],
  );
  return (
    <Questions
      course={course}
      isExam={course.isExam}
      questions={questions}
      questionsSelected={questionsSelected}
      selectedIds={selectedIds}
      {...props}
    />
  );
};

QuestionsContainer.propTypes = {
  chapterId: PropTypes.string,
  course: PropTypes.object.isRequired,
};

QuestionsContainer.defaultProps = {
  chapterId: null,
};

export default React.memo(QuestionsContainer);
